import { put, takeLatest } from 'redux-saga/effects';

import { signup, signin, success, failed } from '../slice/userSlice';
import { postRequest, getRequest, deleteRequest, patchRequest } from './ApiInstence';
import { toast } from 'react-toastify';
import { getEnquire, successEnquire, failedEnquire, removeEnquire } from '../slice/enquireSlice';
import {
  addProduct,
  getProduct,
  updateProduct,
  successProduct,
  removeProduct,
  getOneProduct,
  searchProductByName
} from '../slice/productSlice';
import { getGallery, successGallery, removeGallery, addGallery, updateGallery, getOneGallery } from '../slice/gallerySlice';
// import { getMedia, successMedia, removeMedia, addMedia, updateMedia, getOneMedia } from '../slice/mediaSlice';
// import { updateOrderAPI } from './orderAPI/orderAPI';
import {
  getContactUs,
  successContactUs,
  failedContactUs,
  removeContactUs,
  getDashboardData,
  successDashboard
} from '../slice/contactUsSlice';
import {
  getTeamMessages,
  getOneTeamMessage,
  addTeamMessage,
  updateTeamMessage,
  removeTeamMessage,
  successTeamMessage,
  failedTeamMessage
} from '../slice/teamMessageSlice';
import { getMedia, getOneMedia, addMedia, updateMedia, removeMedia, successMediaList, successSingleMedia } from '../slice/mediaSlice';
import { getStory, getOneStory, addStory, updateStory, removeStory, successStoryList, successSingleStory } from '../slice/storySlice';
import {
  getCategories,
  addCategory,
  updateCategory,
  removeCategory,
  getSubcategories,
  addSubcategory,
  updateSubcategory,
  removeSubcategory,
  successCategories,
  successSubcategories
} from '../slice/categorySlice';

// Generator function

function* signinUser({ payload }) {
  try {
    // You can also export the axios call as a function.
    console.log('ddddddddddddddddddddddddd111111111111');
    let response = yield postRequest('admin/signin', payload, {
      withCredentials: true // Include cookies in the request
    });
    if (response == undefined) {
      response = {
        message: 'something wrong try after sometime'
      };
    }
    if (response?.status == 200) {
      yield put(success(response));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    yield put(failed(error));
  }
}
function* signupUser({ payload }) {
  try {
    const response = yield postRequest('register', payload);
    if (response?.status == 200) {
      yield put(success(response?.data));
    } else {
      yield put(failed(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* getDashboardDataFun({ payload }) {
  try {
    const response = yield getRequest('dashboard', payload);
    if (response?.status === 200) {
      yield put(successDashboard(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedContactUs(error));
  }
}
function* getProductFun() {
  try {
    const response = yield getRequest('product');
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* getOneProductFun({ payload }) {
  try {
    const response = yield getRequest(`product/one/${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* removeProductFun({ payload }) {
  try {
    const response = yield deleteRequest(`product/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('product', payload);
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* addProductFun({ payload }) {
  try {
    const response = yield postRequest(`product`, payload);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* searchProductByNameFun({ payload }) {
  try {
    const response = yield getRequest(`product/search?product=${payload}`);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* updateProductFun({ payload }) {
  try {
    const response = yield patchRequest(`product/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successProduct(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
//Gallery Functions
function* getGalleryFun() {
  try {
    const response = yield getRequest('gallery');
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* getOneGalleryFun({ payload }) {
  try {
    const response = yield getRequest(`gallery/one/${payload}`);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* removeGalleryFun({ payload }) {
  try {
    const response = yield deleteRequest(`gallery/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('gallery', payload);
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* addGalleryFun({ payload }) {
  try {
    const response = yield postRequest(`gallery`, payload);
    if (response?.status == 200 || response?.status == 201) {
      const list = yield getRequest('gallery');
      yield put(successGallery(list?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* updateGalleryFun({ payload }) {
  try {
    const response = yield patchRequest(`gallery/${payload.id}`, payload.data);
    if (response?.status == 200) {
      yield put(successGallery(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
//Media Functions

// GET LIST
function* getMediaFun() {
  try {
    const response = yield getRequest('media');
    if (response?.status === 200) {
      yield put(successMediaList(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}

// GET ONE
function* getOneMediaFun({ payload }) {
  try {
    const response = yield getRequest(`media/one/${payload}`);
    if (response?.status === 200) {
      yield put(successSingleMedia(response.data));
    }
  } catch (error) {
    console.log(error);
  }
}

// ADD
function* addMediaFun({ payload }) {
  try {
    const response = yield postRequest('media', payload);
    if (response?.status === 201 || response?.status === 200) {
      const list = yield getRequest('media');
      yield put(successMediaList(list.data)); // refresh list
    }
  } catch (error) {
    console.log(error);
  }
}

// UPDATE
function* updateMediaFun({ payload }) {
  try {
    const response = yield patchRequest(`media/${payload.id}`, payload.data);
    if (response?.status === 200) {
      const list = yield getRequest('media');
      yield put(successMediaList(list.data));
    }
  } catch (error) {
    console.log(error);
  }
}

// DELETE
function* removeMediaFun({ payload }) {
  try {
    const response = yield deleteRequest(`media/${payload}`);
    if (response?.status === 200) {
      const list = yield getRequest('media');
      yield put(successMediaList(list.data));
    }
  } catch (error) {
    console.log(error);
  }
}

// Story Functions

// GET LIST
function* getStoryFun() {
  try {
    const response = yield getRequest('story');
    if (response?.status === 200) {
      const raw = response?.data?.data ?? response?.data ?? [];
      const list = Array.isArray(raw) ? raw : Array.isArray(raw?.rows) ? raw.rows : Array.isArray(raw?.data) ? raw.data : [];
      yield put(successStoryList(list));
    }
  } catch (error) {
    console.log(error);
  }
}

// GET ONE
function* getOneStoryFun({ payload }) {
  try {
    const response = yield getRequest(`story/one/${payload}`);
    if (response?.status === 200) {
      const raw = response?.data?.data ?? response?.data ?? null;
      const item = Array.isArray(raw) ? raw[0] ?? null : raw;
      yield put(successSingleStory(item));
    }
  } catch (error) {
    console.log(error);
  }
}

// ADD
function* addStoryFun({ payload }) {
  try {
    const response = yield postRequest('story', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    if (response?.status === 201 || response?.status === 200) {
      const list = yield getRequest('story');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successStoryList(data));
    }
  } catch (error) {
    console.log(error);
  }
}

// UPDATE
function* updateStoryFun({ payload }) {
  try {
    const response = yield patchRequest(`story/${payload.id}`, payload.data, { headers: { 'Content-Type': 'multipart/form-data' } });
    if (response?.status === 200) {
      const list = yield getRequest('story');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successStoryList(data));
    }
  } catch (error) {
    console.log(error);
  }
}

// DELETE
function* removeStoryFun({ payload }) {
  try {
    const response = yield deleteRequest(`story/${payload}`);
    if (response?.status === 200) {
      const list = yield getRequest('story');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successStoryList(data));
    }
  } catch (error) {
    console.log(error);
  }
}

// function* getMediaFun() {
//   try {
//     const response = yield getRequest('media');
//     if (response?.status == 200) {
//       yield put(successMedia(response?.data));
//     } else {
//       yield put(failedContactUs(response));
//     }
//   } catch (error) {
//     console.log(error)
//     toast('resposnse.message')
//   }
// }
// function* getOneMediaFun({ payload }) {
//   try {
//     const response = yield getRequest(`media/one/${payload}`);
//     if (response?.status == 200) {
//       yield put(successMedia(response?.data));
//     } else {
//       yield put(failedContactUs(response));
//     }
//   } catch (error) {
//     console.log(error)
//     toast('resposnse.message')
//   }
// }
// function* removeMediaFun({ payload }) {
//   try {
//     const response = yield deleteRequest(`media/${payload}`);
//     if (response?.status == 200) {
//       const response = yield getRequest('media', payload);
//       yield put(successMedia(response?.data));
//     } else {
//       yield put(failedContactUs(response));
//     }
//   } catch (error) {
//     console.log(error)
//     toast('resposnse.message')
//   }
// }
// function* addMediaFun({ payload }) {
//   try {
//     const response = yield postRequest(`media`, payload);
//     if (response?.status == 200) {
//       yield put(successMedia(response?.data));
//     } else {
//       yield put(failedContactUs(response));
//     }
//   } catch (error) {
//     console.log(error)
//     toast('resposnse.message')
//   }
// }
// function* updateMediaFun({ payload }) {
//   try {
//     const response = yield patchRequest(`media/${payload.id}`, payload.data);
//     if (response?.status == 200) {
//       yield put(successMedia(response?.data));
//     } else {
//       yield put(failedContactUs(response));
//     }
//   } catch (error) {
//     console.log(error)
//     toast('resposnse.message')
//   }
// }
// Enquire
function* getEnquireFun({ payload }) {
  try {
    const response = yield getRequest('enquire', payload, payload.header);
    if (response?.status == 200) {
      yield put(successEnquire(response?.data));
    } else {
      yield put(failedEnquire(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* removeEnquireFun({ payload }) {
  try {
    const response = yield deleteRequest(`enquire/${payload}`);
    if (response?.status == 200) {
      const response = yield getRequest('enquire', payload);
      yield put(successEnquire(response?.data));
    } else {
      yield put(failedEnquire(response));
    }
  } catch (error) {
    console.log(error);
    toast('resposnse.message');
  }
}
function* getContactUsFun() {
  try {
    const response = yield getRequest('contactus');
    if (response?.status === 200) {
      yield put(successContactUs(response?.data));
    } else {
      yield put(failedContactUs(response));
    }
  } catch (error) {
    console.log(error);
    yield put(failedContactUs(error));
  }
}
function* removeContactUsFun({ payload }) {
  try {
    const response = yield deleteRequest(`contactus/${payload}`);
    if (response?.status === 200) {
      const list = yield getRequest('contactus');
      yield put(successContactUs(list?.data));
    }
  } catch (error) {
    console.log(error);
  }
}

// Category Functions
function* getCategoriesFun() {
  try {
    const response = yield getRequest('category');
    if (response?.status === 200) {
      const raw = response?.data?.data ?? response?.data ?? [];
      const list = Array.isArray(raw) ? raw : Array.isArray(raw?.rows) ? raw.rows : [];
      yield put(successCategories(list));
    }
  } catch (error) {
    console.log(error);
  }
}
function* addCategoryFun({ payload }) {
  try {
    const response = yield postRequest('category', payload);
    if (response?.status === 201 || response?.status === 200) {
      const list = yield getRequest('category');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successCategories(data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* updateCategoryFun({ payload }) {
  try {
    const response = yield patchRequest(`category/${payload.id}`, payload.data);
    if (response?.status === 200) {
      const list = yield getRequest('category');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successCategories(data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* removeCategoryFun({ payload }) {
  try {
    const response = yield deleteRequest(`category/${payload}`);
    if (response?.status === 200) {
      const list = yield getRequest('category');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successCategories(data));
    }
  } catch (error) {
    console.log(error);
  }
}

// SubCategory Functions
function* getSubcategoriesFun() {
  try {
    const response = yield getRequest('subcategory');
    if (response?.status === 200) {
      const raw = response?.data?.data ?? response?.data ?? [];
      const list = Array.isArray(raw) ? raw : Array.isArray(raw?.rows) ? raw.rows : [];
      yield put(successSubcategories(list));
    }
  } catch (error) {
    console.log(error);
  }
}
function* addSubcategoryFun({ payload }) {
  try {
    const response = yield postRequest('subcategory', payload);
    if (response?.status === 201 || response?.status === 200) {
      const list = yield getRequest('subcategory');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successSubcategories(data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* updateSubcategoryFun({ payload }) {
  try {
    const response = yield patchRequest(`subcategory/${payload.id}`, payload.data);
    if (response?.status === 200) {
      const list = yield getRequest('subcategory');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successSubcategories(data));
    }
  } catch (error) {
    console.log(error);
  }
}
function* removeSubcategoryFun({ payload }) {
  try {
    const response = yield deleteRequest(`subcategory/${payload}`);
    if (response?.status === 200) {
      const list = yield getRequest('subcategory');
      const data = list?.data?.data ?? list?.data ?? [];
      yield put(successSubcategories(data));
    }
  } catch (error) {
    console.log(error);
  }
}

//teammessage satrt
function* getTeamMessagesFun() {
  try {
    const response = yield getRequest('message');
    if (response?.status === 200) {
      yield put(successTeamMessage(response?.data));
    } else {
      yield put(failedTeamMessage(response));
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.message || 'Failed to fetch team messages');
  }
}

// FETCH single team message
function* getOneTeamMessageFun({ payload }) {
  try {
    const response = yield getRequest(`message/${payload}`);
    if (response?.status === 200) {
      yield put(successTeamMessage(response?.data));
    } else {
      yield put(failedTeamMessage(response));
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.message || 'Failed to fetch team message details');
  }
}

// ADD team message
function* addTeamMessageFun({ payload }) {
  try {
    const headers = { 'Content-Type': 'multipart/form-data' };
    const response = yield postRequest('message', payload, headers);
    if (response?.status === 200) {
      yield put(successTeamMessage(response?.data));
    } else {
      yield put(failedTeamMessage(response));
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.message || 'Failed to add team message');
  }
}

// UPDATE team message
// function* updateTeamMessageFun({ payload }) {
//   try {
//     const headers = { 'Content-Type': 'multipart/form-data' };
//     const response = yield patchRequest(`message/${payload.id}`, payload.data, headers);
//     if (response?.status === 200) {
//       yield put(successTeamMessage(response?.data));
//     } else {
//       yield put(failedTeamMessage(response));
//     }
//   } catch (error) {
//     console.log(error);
//     toast.error(error?.message || 'Failed to update team message');
//   }
// }

// ✅ Update TeamMessage
function* updateTeamMessageFun({ payload }) {
  try {
    const response = yield patchRequest(`message/${payload.id}`, payload.data, { 'Content-Type': 'multipart/form-data' });

    if (response?.status === 200) {
      const refresh = yield getRequest('message'); // 🔥 REFRESH LIST
      yield put(successTeamMessage(refresh.data));
    }
  } catch (error) {
    console.error(error);
    toast.error(error.message);
  }
}

// DELETE team message
function* removeTeamMessageFun({ payload }) {
  try {
    const response = yield deleteRequest(`message/${payload}`);
    if (response?.status === 200) {
      const res = yield getRequest('message');
      yield put(successTeamMessage(res?.data));
    } else {
      yield put(failedTeamMessage(response));
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.message || 'Failed to delete team message');
  }
}
//team message end
// function* getDashboardDataaFun({ payload }) {
//   try {
//     const response = yield getRequest('dashboard', payload);
//     if (response?.status == 200) {
//       yield put(successResume(response?.data));
//     } else {
//       yield put(failedResume(response?.data));
//       toast(response?.data?.message || 'Failed to fetch dashboard data');
//     }
//   } catch (error) {
//     console.log(error);
//     toast(error.response?.data?.message || error.message);
//   }
// }
// Generator function
export function* watchGetUser() {
  yield takeLatest(signin, signinUser);
  yield takeLatest(signup, signupUser);
  yield takeLatest(getDashboardData, getDashboardDataFun);
  //Enquire
  yield takeLatest(getEnquire, getEnquireFun);
  yield takeLatest(removeEnquire, removeEnquireFun);
  yield takeLatest(addProduct, addProductFun);
  yield takeLatest(getProduct, getProductFun);
  yield takeLatest(getOneProduct, getOneProductFun);
  yield takeLatest(searchProductByName, searchProductByNameFun);
  yield takeLatest(removeProduct, removeProductFun);
  yield takeLatest(updateProduct, updateProductFun);
  //gallery
  yield takeLatest(addGallery, addGalleryFun);
  yield takeLatest(getGallery, getGalleryFun);
  yield takeLatest(removeGallery, removeGalleryFun);
  yield takeLatest(getOneGallery, getOneGalleryFun);
  yield takeLatest(updateGallery, updateGalleryFun);

  //media
  yield takeLatest(addMedia, addMediaFun);
  yield takeLatest(getMedia, getMediaFun);
  yield takeLatest(removeMedia, removeMediaFun);
  yield takeLatest(getOneMedia, getOneMediaFun);
  yield takeLatest(updateMedia, updateMediaFun);

  // story
  yield takeLatest(addStory, addStoryFun);
  yield takeLatest(getStory, getStoryFun);
  yield takeLatest(removeStory, removeStoryFun);
  yield takeLatest(getOneStory, getOneStoryFun);
  yield takeLatest(updateStory, updateStoryFun);

  // contact us
  yield takeLatest(getContactUs, getContactUsFun);
  yield takeLatest(removeContactUs, removeContactUsFun);

  // category
  yield takeLatest(getCategories, getCategoriesFun);
  yield takeLatest(addCategory, addCategoryFun);
  yield takeLatest(updateCategory, updateCategoryFun);
  yield takeLatest(removeCategory, removeCategoryFun);

  // subcategory
  yield takeLatest(getSubcategories, getSubcategoriesFun);
  yield takeLatest(addSubcategory, addSubcategoryFun);
  yield takeLatest(updateSubcategory, updateSubcategoryFun);
  yield takeLatest(removeSubcategory, removeSubcategoryFun);

  yield takeLatest(getTeamMessages, getTeamMessagesFun);
  yield takeLatest(getOneTeamMessage, getOneTeamMessageFun);
  yield takeLatest(addTeamMessage, addTeamMessageFun);
  yield takeLatest(updateTeamMessage, updateTeamMessageFun);
  yield takeLatest(removeTeamMessage, removeTeamMessageFun);
}
